export default "__VITE_ASSET__c416ef79__"